enum Stage {
  Code,
  Success,
}

export default Stage;
